/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalInfoComponent } from '@pages/gestione-opera/_toolkit/modal-info/modal-info.component';
import { CurrencyMaskInputMode } from 'ngx-currency';

@Component({
    selector: 'app-toolkit-rilievo-tab-anagrafica-rilievo',
    templateUrl: './tab-anagrafica-rilievo.component.html',
})
export class ToolkitGestioneRilievoTabAnagraficaRilievoComponent implements OnInit {


    @Input() canEdit: boolean;
    @Input() formGroup: FormGroup;
    readonly natural = CurrencyMaskInputMode.NATURAL;
    constructor(private modalService: NgbModal) {
    }

    ngOnInit() {
        if (this.canEdit === false) {
            this.formGroup.disable();
        }
    }

    getInfoSelected() {
        const modalRef = this.modalService.open(ModalInfoComponent, { size: 'lg', centered: true });
         modalRef.componentInstance.descriptions = [
            {
                title: 'Soggetto esecutore del rilievo',
                text: 'Inserire l\'ente esecutore del rilievo. Se il rilievo è stato eseguito da un libero professionista inserire la dicitura: "Libero professionista/Società individuale".'
            }
        ];
    }

}
